import React, { useEffect, useRef } from 'react';
import { QRCodeCanvas } from "qrcode.react";
import ihlogo from './assets/images/logo.png';

function QRCodeWithLogo() {
    const canvasRef = useRef(null);
    const qrValue = "https://ih-form.islandhospital.com/nursing/COEForm/language";

    useEffect(() => {
        const canvas = canvasRef.current?.querySelector("canvas");
        if (canvas) {
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.src = ihlogo;
            img.onload = () => {
                const size = canvas.width * 0.2; // 20% of QR code size
                const x = (canvas.width - size) / 2;
                const y = (canvas.height - size) / 2;
                ctx.drawImage(img, x, y, size, size);
            };
        }
    }, []);

    return (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
            <h2>QR Code</h2>
            <div ref={canvasRef}>
                <QRCodeCanvas
                    value={qrValue}
                    size={200}
                    level="H"
                    includeMargin={true}
                />
            </div>
        </div>
    );
};

export default QRCodeWithLogo;
